import React from 'react'
import {PageTitle} from '../../../Molecules/BaseMembersPages/PageTitle'
import {MembersPageTemplate} from '../../../Molecules/BaseMembersPages/MembersPageTemplate'
import {Signboard} from '../../../../DTO/SignboardDTO'
import {ErrorSummary} from '../../../Molecules/ErrorsAndAlert/ErrorSummary/ErrorSummary'
import {PIMSecondaryButton} from '../../../Atoms/Buttons/Bases/PIMSecondaryButton'
import {PIMPageActions} from '../../../Atoms/Layouts/PIMPageActions'
import {Spacer} from '../../../../../Common/Components/Spacer'
import {useTranslation} from 'react-i18next'

type JoinErrorCvsReadyContentProps = {
  signboard: Signboard
  goToAccountTopPage: () => void
  dataTestId?: string
}

export const JoinErrorCvsReadyContent: React.VFC<JoinErrorCvsReadyContentProps> = (
  {
    signboard,
    goToAccountTopPage,
    dataTestId
  }
) => {
  const {t} = useTranslation('member')

  return (
    <MembersPageTemplate signboard={signboard} dataTestId={dataTestId}>
      <PageTitle>{`${signboard.signupName} 新規会員情報入力`}</PageTitle>
      <ErrorSummary
        display={true}
        headline={'現在コンビニお支払い待ちのため、入会のお手続きはできません。'}
        detail={'お支払い方法変更をご希望の場合には、コンビニお支払い期限を過ぎた後に再度入会のお手続きを行ってください。'}
      />
      <Spacer mt={'30px'}>
        <PIMPageActions>
          <PIMSecondaryButton onClick={():void => goToAccountTopPage()}>
            {t('MYアカウント.ページ名')}に移動する
          </PIMSecondaryButton>
        </PIMPageActions>
      </Spacer>
    </MembersPageTemplate>
  )
}
